import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.courseApplyController;
const getIdCardApply = self.customSetting.getIdCardApply;
const postIdCardApply = self.customSetting.postIdCardApply;

export default {
  qryVenCourseList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getIdCardApply}/QryVenCourseList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  qryIdChangePeople: (context, Course_Id) => {
    return axios.get(
      `${baseApi}/${getIdCardApply}/QryIdChangePeople?Course_Id=${Course_Id}`
    );
  },
  cancelIdSignUpList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getIdCardApply}/CancelIdChangeSignUpList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  saveApplyPeople: (context, data) => {
    return axios.post(`${baseApi}/${postIdCardApply}/SaveApplyPeople`, data);
  },
  updCancelIdSignUp: (context, data) => {
    return axios.post(`${baseApi}/${postIdCardApply}/updCancelSignUp`, data);
  },
};
